import { OCriarRelatorioAtividadesi18n } from "@/components/Atividades/OCriarRelatorioAtividades/OCriarRelatorioAtividades.i18n"
import { OTabelaDestravarPeriodoi18n } from "@/components/Atividades/OTabelaDestravarPeriodo/OTabelaDestravarPeriodo.i18n"
import { OTabelaTiposDeAtividadei18n } from "@/components/Atividades/OTabelaTiposDeAtividade/OTabelaTiposDeAtividade.i18n"
import { OTipoAtividadeIdi18n } from "@/components/Atividades/OTipoAtividadeInformacoes/OTipoAtividadeId.i18n"
import { TGestaoTravamentoi18n } from "@/components/Atividades/TGestaoTravamento/TGestaoTravamento.i18n"
import { TTipoDeAtividadesi18n } from "@/components/Atividades/TTipoDeAtividades/TTipoDeAtividades.i18n"
import { OCapacidadeValori18n } from "@/components/AtributoComValor/OCapacidadeValor/OCapacidadeValor.i18n"
import { OCapacidadeValorListai18n } from "@/components/AtributoComValor/OCapacidadeValorLista/OCapacidadeValorLista.i18n"
import { OCaracteristicaValorListai18n } from "@/components/AtributoComValor/OCaracteristicaValorLista/OCaracteristicaValorLista.i18n"
import { OHorasi18n } from "@/components/AtributoComValor/OHoras/OHoras.i18n"
import { OAdicionarAtributoi18n } from "@/components/Atributos/OAdicionarAtributo/OAdicionarAtributo.i18n"
import { OAtributosEsperadosi18n } from "@/components/Atributos/OAtributosEsperados/OAtributosEsperados.i18n"
import { OCriarAtributoi18n } from "@/components/Atributos/OCriarAtributo/OCriarAtributo.i18n"
import { OTabelaAtributosi18n } from "@/components/Atributos/OTabelaAtributos/OTabelaAtributos.i18n"
import { ABotaoDeAcaoi18n } from "@/components/Calendario/ABotaoDeAcao/ABotaoDeAcao.i18n"
import { MEventoPeriodoi18n } from "@/components/Calendario/DetalhesEventoPlanejado/MEventoPeriodo/MEventoPeriodo.i18n"
import { ODetalhesEventoPlanejadoi18n } from "@/components/Calendario/DetalhesEventoPlanejado/ODetalhesEventoPlanejado/ODetalhesEventoPlanejado.i18n"
import { OListaDeProfissionaisi18n } from "@/components/Calendario/DetalhesEventoPlanejado/OListaDeProfissionais/OListaDeProfissionais.i18n"
import { OCriarEventoi18n } from "@/components/Calendario/OCriarEvento/OCriarEvento.i18n"
import { OCriarEventoPlanejadoi18n } from "@/components/Calendario/OCriarEventoPlanejado/OCriarEventoPlanejado.i18n"
import { ODetalhesEventoi18n } from "@/components/Calendario/ODetalhesEvento/ODetalhesEvento.i18n"
import { OEditarPlanejamentoAtividadei18n } from "@/components/Calendario/OEditarPlanejamentoAtividade/OEditarPlanejamentoAtividade.i18n"
import { OIniciarAtividadeRealizadaNaoPlanejadai18n } from "@/components/Calendario/OIniciarAtividadeRealizadaNaoPlanejada/OIniciarAtividadeRealizadaNaoPlanejada.i18n"
import { OModalExcluirAtividadei18n } from "@/components/Calendario/OModalExcluirAtividade/OModalExcluirAtividade.i18n"
import { OSeletorSemanali18n } from "@/components/Calendario/OSeletorSemanal/OSeletorSemanal.i18n"
import { OTravarPeriodoi18n } from "@/components/Calendario/OTravarPeriodo/OTravarPeriodo.i18n"
import { TCriarNovaSenhai18n } from "@/components/Conta/TCriarNovaSenha/TCriarNovaSenha.18n"
import { TLogini18n } from "@/components/Conta/TLogin/TLogin.i18n"
import { TRecuperacaoDeSenhai18n } from "@/components/Conta/TRecuperacaoDeSenha/TRecuperacaoDeSenha.i18n"
import { TSingleSignOni18n } from "@/components/Conta/TSingleSignOn/TSingleSignOni18n"
import { MAtividadesComOcorrenciai18n } from "@/components/Estatisticas/MAtividadesComOcorrencia/MAtividadesComOcorrencia.i18n"
import { MGraficoAtividadesPorPeriodoi18n } from "@/components/Estatisticas/MGraficoAtividadesPorPeriodo/MGraficoAtividadesPorPeriodo.i18n"
import { TPainelDeEstatisticasi18n } from "@/components/Estatisticas/TPainelDeEstatisticas/TPainelDeEstatisticas.i18n"
import { ACarregamentoCalendarioi18n } from "@/components/Gerais/ACarregamentoCalendario/ACarregamentoCalendario.i18n"
import { AEstadoVazioTabelai18n } from "@/components/Gerais/AEstadoVazioTabela/AEstadoVazioTabela.i18n"
import { APaginadorDeTabelai18n } from "@/components/Gerais/APaginadorDeTabela/APaginadorDeTabela.i18n"
import { MBotoesRodapei18n } from "@/components/Gerais/MBotoesRodape/MBotoesRodape.i18n"
import { MDropdowni18n } from "@/components/Gerais/MDropdown/MDropdown.i18n"
import { MEntradaDeBuscai18n } from "@/components/Gerais/MEntradaDeBusca/MEntradaDeBusca.i18n"
import { MModalSeletorRadioi18n } from "@/components/Gerais/MModalSeletorRadio/MModalSeletorRadio.i18n"
import { MMultiSelecti18n } from "@/components/Gerais/MMultiSelect/MMultiSelect.i18n"
import { MTextoAssincronoi18n } from "@/components/Gerais/MTextoAssincrono/MTextoAssincrono.i18n"
import { OArvoreDeSelecoesi18n } from "@/components/Gerais/OArvoreDeSelecoes/OArvoreDeSelecoes.i18n"
import { OCabecalhoPeriodoEntreDatasi18n } from "@/components/Gerais/OCabecalhoPeriodoEntreDatas/OCabecalhoPeriodoEntreDatas.i18n"
import { OHeaderi18n } from "@/components/Gerais/OHeader/OHeader.i18n"
import { MCarregadorDeArquivosi18n } from "@/components/Importacoes/MCarregadorDeArquivos/MCarregadorDeArquivos.i18n"
import { TImportacoesi18n } from "@/components/Importacoes/TImportacoes/TImportacoes.i18n"
import { OTabelaProfissionais18n } from "@/components/Profissionais/OTabelaProfissionais/OTabelaProfissionais.i18n"
import { TProfissionali18n } from "@/components/Profissionais/TProfissional/TProfissional.i18n"
import { AListaDeItensi18n } from "@/components/Projetos/AListaDeItens/AListaDeItens.i18n"
import { MCabecalhoTabelaGrupoi18n } from "@/components/Projetos/MCabecalhoTabelaGrupo/MCabecalhoTabelaGrupo.i18n"
import { MListaDeGruposi18n } from "@/components/Projetos/MListaDeGrupos/MListaDeGrupos.i18n"
import { ODadosGrupoi18n } from "@/components/Projetos/ODadosGrupo/ODadosGrupo.i18n"
import { ODadosProjetoi18n } from "@/components/Projetos/ODadosProjeto/ODadosProjeto.i18n"
import { OEditarGruposi18n } from "@/components/Projetos/OEditarGrupos/OEditarGrupos.i18n"
import { ONovaAtividadei18n } from "@/components/Projetos/ONovaAtividade/ONovaAtividade.i18n"
import { ONovoMembroi18n } from "@/components/Projetos/ONovoMembro/ONovoMembro.i18n"
import { OSelecionarMembrosProjetoi18n } from "@/components/Projetos/OSelecionarMembrosProjeto/OSelecionarMembrosProjeto.i18n"
import { OSelecionarProjetosGrupoi18n } from "@/components/Projetos/OSelecionarProjetosGrupo/OSelecionarProjetosGrupo.i18n"
import { OSelecionarTiposDeAtividadei18n } from "@/components/Projetos/OSelecionarTiposDeAtividade/OSelecionarTiposDeAtividade.i18n"
import { OTabelaAcordeaoProjetosi18n } from "@/components/Projetos/OTabelaAcordeaoProjetos/OTabelaAcordeaoProjetosi18n"
import { OTabelaMembrosProjetoi18n } from "@/components/Projetos/OTabelaMembrosProjeto/OTabelaMembrosProjeto.i18n"
import { OTabelaProjetosi18n } from "@/components/Projetos/OTabelaProjetos/OTabelaProjetos.i18n"
import { TProjetosi18n } from "@/components/Projetos/TProjetos/TProjetos.i18n"
import { OAtributosAlocacaoUsuarioi18n } from "@/components/Usuarios/OAtributosAlocacaoUsuario/OAtributosAlocacaoUsuario.i18n"
import { ODadosResponsabilidadeUsuarioi18n } from "@/components/Usuarios/ODadosResponsabilidadeUsuario/ODadosResponsabilidadeUsuario.i18n"
import { OTabelaUsuariosAtivosi18n } from "@/components/Usuarios/OTabelaUsuariosAtivos/OTabelaUsuariosAtivos.i18n"
import { OTabelaUsuariosInativosi18n } from "@/components/Usuarios/OTabelaUsuariosInativos/OTabelaUsuariosInativos.i18n"
import { OUsuarioInformacoesi18n } from "@/components/Usuarios/OUsuarioInformacoes/OUsuarioInformacoes.i18n"
import { usarDataHorai18n } from "@/composable/UsarDataHora/usarDataHora.i18n"
import { UsarLeitorDeDadosi18n } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados.i18n"
import { CalendarioDeAtividadesi18n } from "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.i18n"
import { GestaoTravamentoi18n } from "@/paginas/Atividades/GestaoTravamento/GestaoTravamento.i18n"
import { NovoTipoAtividadei18n } from "@/paginas/Atividades/NovoTipoAtividade/NovoTipoAtividade.i18n"
import { Logini18n } from "@/paginas/Conta/Login/Login.i18n"
import { Estatisticasi18n } from "@/paginas/Estatisticas/Estatisticas.i18n"
import { ListarDeProfissionaisi18n } from "@/paginas/Profissionais/ListaDeProfissionais/ListaDeProfissionais.i18n"
import { NovoProfissionali18n } from "@/paginas/Profissionais/NovoProfissional/NovoProfissional.i18n"
import { NovoGrupoi18n } from "@/paginas/Projetos/NovoGrupo/NovoGrupo.i18n"
import { NovoProjetoi18n } from "@/paginas/Projetos/NovoProjeto/NovoProjeto.i18n"
import { ListaDeUsuariosi18n } from "@/paginas/Usuarios/ListaDeUsuarios/ListaDeUsuarios.i18n"
import { NovoUsuarioi18n } from "@/paginas/Usuarios/NovoUsuario/NovoUsuario.i18n"
import { errosi18n } from "@/repositorios/erros.i18n"
import { routeri18n } from "@/router/router.i18n"
import { ListarAtividadesi18n } from "@/store/atividades/ListarAtividades/ListarAtividades.i18n"
import { ListarEstatisticasi18n } from "@/store/estatisticas/ListarEstatisticas/ListarEstatisticas.i18n"
import { typesi18n } from "@/types/types.18n"

const ptBR = Object.assign(
  OCriarEventoi18n["pt-BR"],
  TLogini18n["pt-BR"],
  Logini18n["pt-BR"],
  OHeaderi18n["pt-BR"],
  OTabelaProfissionais18n["pt-BR"],
  APaginadorDeTabelai18n["pt-BR"],
  CalendarioDeAtividadesi18n["pt-BR"],
  MDropdowni18n["pt-BR"],
  MMultiSelecti18n["pt-BR"],
  OSeletorSemanali18n["pt-BR"],
  MEntradaDeBuscai18n["pt-BR"],
  OArvoreDeSelecoesi18n["pt-BR"],
  ACarregamentoCalendarioi18n["pt-BR"],
  ODetalhesEventoPlanejadoi18n["pt-BR"],
  MEventoPeriodoi18n["pt-BR"],
  OListaDeProfissionaisi18n["pt-BR"],
  OCriarEventoPlanejadoi18n["pt-BR"],
  OEditarPlanejamentoAtividadei18n["pt-BR"],
  MModalSeletorRadioi18n["pt-BR"],
  OModalExcluirAtividadei18n["pt-BR"],
  OCriarRelatorioAtividadesi18n["pt-BR"],
  OCabecalhoPeriodoEntreDatasi18n["pt-BR"],
  MAtividadesComOcorrenciai18n["pt-BR"],
  MGraficoAtividadesPorPeriodoi18n["pt-BR"],
  Estatisticasi18n["pt-BR"],
  TRecuperacaoDeSenhai18n["pt-BR"],
  TCriarNovaSenhai18n["pt-BR"],
  ListarDeProfissionaisi18n["pt-BR"],
  TProfissionali18n["pt-BR"],
  OUsuarioInformacoesi18n["pt-BR"],
  NovoUsuarioi18n["pt-BR"],
  ODadosResponsabilidadeUsuarioi18n["pt-BR"],
  OAtributosAlocacaoUsuarioi18n["pt-BR"],
  NovoProfissionali18n["pt-BR"],
  OCaracteristicaValorListai18n["pt-BR"],
  OCapacidadeValorListai18n["pt-BR"],
  MBotoesRodapei18n["pt-BR"],
  TTipoDeAtividadesi18n["pt-BR"],
  OTabelaTiposDeAtividadei18n["pt-BR"],
  OTipoAtividadeIdi18n["pt-BR"],
  NovoTipoAtividadei18n["pt-BR"],
  TProjetosi18n["pt-BR"],
  AListaDeItensi18n["pt-BR"],
  OTabelaProjetosi18n["pt-BR"],
  MEventoPeriodoi18n["pt-BR"],
  MCabecalhoTabelaGrupoi18n["pt-BR"],
  NovoProjetoi18n["pt-BR"],
  ODadosProjetoi18n["pt-BR"],
  ONovoMembroi18n["pt-BR"],
  ONovaAtividadei18n["pt-BR"],
  OSelecionarMembrosProjetoi18n["pt-BR"],
  OSelecionarTiposDeAtividadei18n["pt-BR"],
  OSelecionarProjetosGrupoi18n["pt-BR"],
  NovoGrupoi18n["pt-BR"],
  MListaDeGruposi18n["pt-BR"],
  ODetalhesEventoi18n["pt-BR"],
  TPainelDeEstatisticasi18n["pt-BR"],
  OEditarGruposi18n["pt-BR"],
  OTabelaUsuariosAtivosi18n["pt-BR"],
  OTabelaUsuariosInativosi18n["pt-BR"],
  ListaDeUsuariosi18n["pt-BR"],
  usarDataHorai18n["pt-BR"],
  AEstadoVazioTabelai18n["pt-BR"],
  TGestaoTravamentoi18n["pt-BR"],
  OTravarPeriodoi18n["pt-BR"],
  GestaoTravamentoi18n["pt-BR"],
  OTabelaDestravarPeriodoi18n["pt-BR"],
  TImportacoesi18n["pt-BR"],
  MCarregadorDeArquivosi18n["pt-BR"],
  OIniciarAtividadeRealizadaNaoPlanejadai18n["pt-BR"],
  TSingleSignOni18n["pt-BR"],
  errosi18n["pt-BR"],
  ListarEstatisticasi18n["pt-BR"],
  OHorasi18n["pt-BR"],
  ODadosGrupoi18n["pt-BR"],
  ABotaoDeAcaoi18n["pt-BR"],
  OAtributosEsperadosi18n["pt-BR"],
  OTabelaAtributosi18n["pt-BR"],
  OCriarAtributoi18n["pt-BR"],
  OAdicionarAtributoi18n["pt-BR"],
  OCapacidadeValori18n["pt-BR"],
  MTextoAssincronoi18n["pt-BR"],
  ListarAtividadesi18n["pt-BR"],
  UsarLeitorDeDadosi18n["pt-BR"],
  OTabelaMembrosProjetoi18n["pt-BR"],
  OTabelaAcordeaoProjetosi18n["pt-BR"],
  routeri18n["pt-BR"],
  typesi18n["pt-BR"]
)

const esCO = Object.assign(
  OCriarEventoi18n["es-CO"],
  TLogini18n["es-CO"],
  Logini18n["es-CO"],
  OHeaderi18n["es-CO"],
  OTabelaProfissionais18n["es-CO"],
  APaginadorDeTabelai18n["es-CO"],
  CalendarioDeAtividadesi18n["es-CO"],
  MDropdowni18n["es-CO"],
  MMultiSelecti18n["es-CO"],
  OSeletorSemanali18n["es-CO"],
  MEntradaDeBuscai18n["es-CO"],
  OArvoreDeSelecoesi18n["es-CO"],
  ACarregamentoCalendarioi18n["es-CO"],
  ODetalhesEventoPlanejadoi18n["es-CO"],
  MEventoPeriodoi18n["es-CO"],
  OListaDeProfissionaisi18n["es-CO"],
  OCriarEventoPlanejadoi18n["es-CO"],
  OEditarPlanejamentoAtividadei18n["es-CO"],
  MModalSeletorRadioi18n["es-CO"],
  OModalExcluirAtividadei18n["es-CO"],
  OCriarRelatorioAtividadesi18n["es-CO"],
  OCabecalhoPeriodoEntreDatasi18n["es-CO"],
  MAtividadesComOcorrenciai18n["es-CO"],
  MGraficoAtividadesPorPeriodoi18n["es-CO"],
  Estatisticasi18n["es-CO"],
  TRecuperacaoDeSenhai18n["es-CO"],
  TCriarNovaSenhai18n["es-CO"],
  ListarDeProfissionaisi18n["es-CO"],
  TProfissionali18n["es-CO"],
  OUsuarioInformacoesi18n["es-CO"],
  NovoUsuarioi18n["es-CO"],
  ODadosResponsabilidadeUsuarioi18n["es-CO"],
  OAtributosAlocacaoUsuarioi18n["es-CO"],
  NovoProfissionali18n["es-CO"],
  OCaracteristicaValorListai18n["es-CO"],
  OCapacidadeValorListai18n["es-CO"],
  MBotoesRodapei18n["es-CO"],
  TTipoDeAtividadesi18n["es-CO"],
  OTabelaTiposDeAtividadei18n["es-CO"],
  OTipoAtividadeIdi18n["es-CO"],
  NovoTipoAtividadei18n["es-CO"],
  TProjetosi18n["es-CO"],
  AListaDeItensi18n["es-CO"],
  OTabelaProjetosi18n["es-CO"],
  MCabecalhoTabelaGrupoi18n["es-CO"],
  NovoProjetoi18n["es-CO"],
  ODadosProjetoi18n["es-CO"],
  ONovoMembroi18n["es-CO"],
  ONovaAtividadei18n["es-CO"],
  OSelecionarMembrosProjetoi18n["es-CO"],
  OSelecionarTiposDeAtividadei18n["es-CO"],
  OSelecionarProjetosGrupoi18n["es-CO"],
  NovoGrupoi18n["es-CO"],
  MListaDeGruposi18n["es-CO"],
  ODetalhesEventoi18n["es-CO"],
  TPainelDeEstatisticasi18n["es-CO"],
  OEditarGruposi18n["es-CO"],
  OTabelaUsuariosAtivosi18n["es-CO"],
  OTabelaUsuariosInativosi18n["es-CO"],
  ListaDeUsuariosi18n["es-CO"],
  usarDataHorai18n["es-CO"],
  AEstadoVazioTabelai18n["es-CO"],
  TGestaoTravamentoi18n["es-CO"],
  OTravarPeriodoi18n["es-CO"],
  GestaoTravamentoi18n["es-CO"],
  OTabelaDestravarPeriodoi18n["es-CO"],
  TImportacoesi18n["es-CO"],
  MCarregadorDeArquivosi18n["es-CO"],
  OIniciarAtividadeRealizadaNaoPlanejadai18n["es-CO"],
  TSingleSignOni18n["es-CO"],
  errosi18n["es-CO"],
  ListarEstatisticasi18n["es-CO"],
  OHorasi18n["es-CO"],
  ODadosGrupoi18n["es-CO"],
  ABotaoDeAcaoi18n["es-CO"],
  OAtributosEsperadosi18n["es-CO"],
  OTabelaAtributosi18n["es-CO"],
  OCriarAtributoi18n["es-CO"],
  OAdicionarAtributoi18n["es-CO"],
  OCapacidadeValori18n["es-CO"],
  MTextoAssincronoi18n["es-CO"],
  ListarAtividadesi18n["es-CO"],
  UsarLeitorDeDadosi18n["es-CO"],
  OTabelaMembrosProjetoi18n["es-CO"],
  OTabelaAcordeaoProjetosi18n["es-CO"],
  routeri18n["es-CO"],
  typesi18n["es-CO"]
)

export const idiomas = {
  "pt-BR": ptBR,
  "es-CO": esCO
}
